import { Component, Input } from '@angular/core';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { FontType, FontWeight, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-account-closed',
  template: `
    <fl-page-layout>
      <fl-page-layout-single>
        <fl-bit class="ClosedAccountContainer">
          <fl-heading
            i18n="Account closed heading"
            [flMarginBottom]="Margin.MID"
            [headingType]="HeadingType.H1"
            [size]="TextSize.XLARGE"
          >
            Account Closed
          </fl-heading>

          <fl-text i18n="Closed account message">
            Account of
            <fl-text [fontType]="FontType.SPAN" [weight]="FontWeight.BOLD">
              {{ username }}
            </fl-text>
            has been closed.
          </fl-text>
        </fl-bit>
      </fl-page-layout-single>
    </fl-page-layout>
  `,
  styleUrls: ['./user-profile-account-closed.component.scss'],
})
export class UserProfileAccountClosedComponent {
  TextSize = TextSize;
  HeadingType = HeadingType;
  FontWeight = FontWeight;
  FontType = FontType;
  Margin = Margin;

  @Input() username: string;
}
